// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const counter_ESHOPS = ["%(counter)s e-shop", "%(counter)s e-shopy", "%(counter)s e-shopov"];
export const counter_VARIANTS = ["%(counter)s variant", "%(counter)s varianty", "%(counter)s variantov"];
export const STROLLER_STROLLEROPEDIA = "Ko\u010d\u00edkop\u00e9dia";
